<template>
  <div>
    <div class="qrcode-decoder relative">
      <qrcode-stream v-if="!isLoading" @decode="onDecode" @init="onInit"></qrcode-stream>
      <span v-if="error">{{ error }}</span>
      <form  class="qrcode-form absolute w-full" method="POST" @submit="formSubmit">
        <input type="hidden" name="_token" :value="csrfToken">
        <slot></slot>
        <textarea class="qrcode-input h-0 p-0 m-0" v-model="result"></textarea>
        <button type="submit" v-if="!isLoading" :class="{ 'is-filled': result !== '' }" class="button m-auto text-white text-center bg-green-600 w-full rounded p-2 block">
          {{ $t("Submit") }}
        </button>
      </form>
    </div>

    <div v-if="isLoading" class="flex items-center justify-center min-h-screen bg-white">
      <div class="flex flex-col items-center">
        <div class="flex items-center justify-center mb-4">

          <div class="relative">
            <div
              class="w-12 h-12 rounded-full absolute border-8 border-dashed border-gray-200"
            ></div>

            <div
              class="w-12 h-12 rounded-full animate-spin absolute border-8 border-dashed border-purple-500 border-t-transparent"
            ></div>
          </div>
        </div>
        <div>
          <p class="text-lg text-gray-600">
            {{ $t('System is working... Please wait.') }}
          </p>
        </div>
      </div>
    </div>
</div>
</template>
<script>
import { QrcodeStream } from 'vue-qrcode-reader'
import Swal from 'sweetalert2';

export default {
  components: {
    QrcodeStream
  },
  data() {
    return {
      result: "",
      error: "",
      csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      isLoading:false
    }
  },
  created() {
  axios.defaults.headers.common['X-CSRF-TOKEN'] = this.csrfToken;
 },
  methods: {
    onDecode(result) {
      this.result = result
      console.log('QR Code Result:', result)
    },
    onInit(promise) {
      promise
        .then(() => {
          console.log('QR Code Reader initialized successfully')
        })
        .catch(error => {
          this.error = "Error initializing QR code reader: " + error.message
        })
    },
    formSubmit(e) {
      e.preventDefault()
      this.isLoading = true; // Start loader
      axios
        .post("store", {
          result: this.result
        },{
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
  
       }}
      )
        .then(response => {          

          if(response.status == 200){
          const urlParts = response.data.data.iprofile_token.split('-');
            if(urlParts[0] == 'guru'){
                Swal.fire({
                              icon: "info", 
                              title: "Qrcode", 
                              html:'Questo tipo di QRCode non è supportato da Virtual Coach', 
                              confirmButtonText: "OK",
                        });

            }else{
            window.location.href = `/users/${response.data.data.id}/show`
            }
            this.isLoading = false
          }
        })
        .catch(error => {
          this.isLoading = false; // Set loading state to false on error
          this.error = "Form submission error: " + error.message
        })
    }
  }
}
</script>

<style scoped>
.error {
  font-weight: bold;
  color: red;
}

.qrcode-decoder {
  width: 100vw;
  height: 60vh; /* 60% of the screen height */
  display: flex;
  justify-content: center;
  align-items: center;
}

.qrcode-stream {
  width: 90vw;
  height: 90vw; /* Make it square */
  max-width: 350px; /* Limit maximum size */
  max-height: 350px; /* Keep the height proportional */
  border-radius: 10px;
  overflow: hidden;
}

.qrcode-input {
  visibility: hidden;
}

.button {
  display: none;
}

.button.is-filled {
  display: block;
  margin: 0 auto;
}

#showMessage {
  animation: cssAnimation 0s 5s forwards;
  visibility: hidden;
}


